import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import KanbanEnterpriseColumn from "./KanbanEnterpriseColumn";
import KanbanCardPreview from "./KanbanCardPreview";

const useStyles = makeStyles((theme) => ({
  board: {
    display: "flex",
    gap: theme.spacing(1.5),
    flex: 1,
    minHeight: 0,
    overflowX: "auto",
    overflowY: "hidden",
    padding: theme.spacing(0.5),
    "&::-webkit-scrollbar": { height: 6 },
    "&::-webkit-scrollbar-thumb": {
      background: "rgba(128,128,128,0.3)",
      borderRadius: 4,
    },
  },
}));

const KanbanEnterpriseBoard = ({
  columns = [],
  columnTickets = {},
  columnCounts = {},
  columnHasMore = {},
  columnLoading = {},
  onLoadMore,
  onDragEnd,
  onEditColumn,
  onColumnRename,
  onQuickAction,
  isAdmin = false,
  viewMode = "comfortable",
  cardStyle = "rich",
}) => {
  const classes = useStyles();
  const [previewTicket, setPreviewTicket] = useState(null);
  const [previewAnchor, setPreviewAnchor] = useState(null);

  const handleHoverCard = useCallback((ticket, el) => {
    setPreviewTicket(ticket);
    setPreviewAnchor(el);
  }, []);

  const handleLeaveCard = useCallback(() => {
    setPreviewTicket(null);
    setPreviewAnchor(null);
  }, []);

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        {/* Droppable horizontal para reordenar lanes */}
        <Droppable
          droppableId="board"
          direction="horizontal"
          type="LANE"
        >
          {(boardProvided) => (
            <div
              ref={boardProvided.innerRef}
              {...boardProvided.droppableProps}
              className={classes.board}
            >
              {columns.map((col, index) => (
                <Draggable
                  key={col.id}
                  draggableId={`lane-${col.id}`}
                  index={index}
                  isDragDisabled={!isAdmin}
                >
                  {(dragProvided, dragSnapshot) => (
                    <div
                      ref={dragProvided.innerRef}
                      {...dragProvided.draggableProps}
                      style={{
                        ...dragProvided.draggableProps.style,
                        opacity: dragSnapshot.isDragging ? 0.85 : 1,
                      }}
                    >
                      <KanbanEnterpriseColumn
                        column={col}
                        tickets={columnTickets[col.id] || []}
                        count={columnCounts[col.id] || 0}
                        hasMore={columnHasMore[col.id] || false}
                        loading={columnLoading[col.id] || false}
                        onLoadMore={onLoadMore}
                        onEditColumn={onEditColumn}
                        onColumnRename={onColumnRename}
                        onHoverCard={handleHoverCard}
                        onLeaveCard={handleLeaveCard}
                        onQuickAction={onQuickAction}
                        dragHandleProps={dragProvided.dragHandleProps}
                        isAdmin={isAdmin}
                        viewMode={viewMode}
                        cardStyle={cardStyle}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {boardProvided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <KanbanCardPreview
        ticket={previewTicket}
        anchorEl={previewAnchor}
        onClose={handleLeaveCard}
      />
    </>
  );
};

export default KanbanEnterpriseBoard;
